import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Button, Dialog, Select, Table } from 'components';
import { Field, Form, Formik } from 'formik';
import { useQuery } from 'hooks/useQuery';
import { launchPrivider } from 'services';

import { DialogRemoveVinc } from '../DialogRemoveVinc';

const columns = [
  { label: 'Cliente', align: 'center' },
  { label: 'Cliente OPV', align: 'center' },
  { label: 'Excluir', align: 'center' },
];

export const DialogRegisterVinc = ({ open, onClose, line }) => {
  if (!open) return null;

  const [isLoading, setIsLoading] = useState(false);
  const [clientsVinc, , , reftchClientsVinc] = useQuery(
    () => launchPrivider.findVincClientsLaunchById({ id: line?.idCadastro }),
    [line],
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [clientsOpv, setClientsOpv] = useState([]);
  const [openDialogRemoveVinc, setOpenDialogRemoveVinc] = useState(false);
  const [rowData, setRowData] = useState({});

  const handleClientsOpv = async () => {
    setIsLoading(true);
    try {
      const { data } = await launchPrivider.findClientsOPV({ id: line?.idCadastro });
      setClientsOpv(data);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Erro ao buscar Clientes OPV!');
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    if (values?.client?.length === 0) {
      toast.error('Selecione ao menos 1 cliente para fazer o vinculo!');
      setIsLoading(false);
      return;
    }

    try {
      await launchPrivider.createVincWithClientsOpv({
        idCabec: line?.idCadastro,
        ids_client_opv: values?.client,
      });
      toast.success('Vinculo feito com sucesso!');
      resetForm();
      reftchClientsVinc();
      handleClientsOpv();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Erro ao fazer vinculo!');
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const pagined = clientsVinc?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  useEffect(() => {
    if (line) {
      handleClientsOpv();
    }
    // eslint-disable-next-line
  }, [line]);

  const handleOpenDialogRemoveVinc = (item) => {
    setRowData(item);
    setOpenDialogRemoveVinc(true);
  };

  const handleCloseDialogRemoveVinc = () => {
    setOpenDialogRemoveVinc(false);
    reftchClientsVinc();
    handleClientsOpv();
  };
  return (
    <>
      <Dialog open={open} maxWidth={'md'}>
        <Dialog.Title onClose={onClose}>Registrar Vinculos para o {line?.cliente}</Dialog.Title>
        <Formik initialValues={{ client: [] }} onSubmit={onSubmit}>
          <Form>
            <Dialog.Content>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Field
                    multiple
                    size='small'
                    name='client'
                    label='Selecione o cliente'
                    variant='outlined'
                    options={clientsOpv}
                    component={Select}
                    loading={isLoading}
                  />
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: '1rem' }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Table
                    headers={columns}
                    disableNumeration
                    emptyMessage='Nenhum vinculo encontrado'
                  >
                    {pagined?.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell align='center'>{item?.cliente}</TableCell>
                        <TableCell align='center'>{item?.clienteOpv}</TableCell>
                        <TableCell align='center'>
                          <IconButton
                            color='secondary'
                            onClick={() => handleOpenDialogRemoveVinc(item)}
                          >
                            <HighlightOffIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </Table>
                  <TablePagination
                    component='div'
                    count={clientsVinc?.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    labelRowsPerPage='Linhas por página'
                  />
                </Grid>
              </Grid>
            </Dialog.Content>
            <Dialog.Actions>
              <Button fullWidth color='secondary' onClick={onClose} loading={isLoading}>
                Cancelar
              </Button>
              <Button fullWidth loading={isLoading} type='submit'>
                Vincular
              </Button>
            </Dialog.Actions>
          </Form>
        </Formik>
      </Dialog>

      <DialogRemoveVinc
        open={openDialogRemoveVinc}
        onClose={handleCloseDialogRemoveVinc}
        rowData={rowData}
      />
    </>
  );
};
